import Vue from 'vue';
import de from 'vuetify/es5/locale/de';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    customProperties: true,
    lang: {
        locales: { de },
        current: 'de',
    },
    theme: {
        themes: {
            light: {
                primary: '#c1c1c1',
                secondary: '#115b6e',
                accent: '#222222',
                error: '#db4035',
                warning: '#efba00',
                info: '#fafafa',
                success: '#439460',
                black: '#222222',
            },
        },
    },
});

// gruen #429460
// rot #DB4035
// schwarz #222222
// weiß #ffffff
// weiß dunkel #fafafa
// blau #1365c0
// grau #ebebeb
// grau dunkel #c1c1c1
// grau ganz dunkel #878787
// grau hintergrund #f9f9f9
